<template>
    <div>

        <kgr-dropdown
            display="name"
            :options="options"
            :label="$t('basfi.select.kindergarten.label')"
            :loading="loading"
            @post-input="onSelect"
        />
        <br />
        <kgr-basfi-reporting
            v-if="config != null"
            :config="config"
            context="federation"
        />
    </div>
</template>

<script>
import BasfiKindergartenConfigRepository from '../../js/repository/BasfiKindergartenConfigRepository';
import BasfiReporting from './Reporting.vue';
import Dropdown from '../../components/common/form/select/Dropdown.vue';

export default {
    components: {
        'kgr-basfi-reporting': BasfiReporting,
        'kgr-dropdown': Dropdown,
    },
    props: {
        federationId: {
            type: Number,
            required: true
        },
    },
    data() {
        return {
            loading: true,
            options: [],
            configs: [],
            config: null,
        }
    },
    created() {
        this.loadInit();
    },
    methods: {
        onSelect(option) {
            this.config = option === null ? null : this.configs.find(config => config.kindergarten.id === option.id)
        },
        loadInit() {
            BasfiKindergartenConfigRepository
                .findByFederationId(this.federationId)
                .then(configs => {
                    this.configs = configs;
                    this.options = configs.map(config => config.kindergarten);
                    this.loading = false;
                });
        },
    },
}
</script>
